import React, { useEffect, useState } from "react";

const InstagramSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("/posts.json")
      .then((res) => res.json())
      .then((data) => setPosts(data.slice(0, 8))) // limitar a 8 posts
      .catch((err) => console.error("Erro ao carregar os posts do Instagram", err));
  }, []);

  return (
    <div style={{ maxWidth: "100%", padding: "2rem 1rem", textAlign: "center" }}>
      {/* Título da seção */}
      <h2 className="contact-title">Reflexões no Instagram</h2>

      {/* Cabeçalho fixo do perfil */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1.5rem",
        marginBottom: "2rem",
        flexWrap: "wrap"
      }}>
        <img
          src="/instagram/profile.png"
          alt="Psicólogo Marcelo Martins"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "2px solid #ccc"
          }}
        />
        <div>
          <p style={{ margin: 0, fontStyle: "italic" }}>
            Psicólogo Marcelo Martins <br />
            Psicólogo clínico – CRP 06/123456 <br />
            Atendimento individual, casal e familiar
          </p>
          <p style={{ margin: "0.5rem 0", color: "#666" }}>+593 seguidores</p>
        </div>
      </div>

      {/* Feed com os posts */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "16px"
      }}>
        {posts.map((post, index) => (
          <a
            key={index}
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block",
              width: "calc(25% - 12px)", // 4 por linha com espaço
              minWidth: "200px",
              aspectRatio: "1 / 1",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              backgroundColor: "#f3f3f3"
            }}
          >
            <img
              src={post.image}
              alt={`Post ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block"
              }}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default InstagramSection;
